<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('sales')">Vendita</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.sku }}
    </h1>
    <trashed-message v-if="sale.deleted_at" class="mb-6" @restore="restore"> Questa vendita è stato cancellata. </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/2" label="SKU" />
          <text-input v-model="form.sku2" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/2" label="SKU2" />
          <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <!-- <button v-if="!sale.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Elimina Vendita</button> -->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Aggiorna Vendita</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `Elimina Vendita`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    sale: Object,
    batches: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: this.sale.sku,
        sku2: this.sale.sku2,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('sales.update', this.sale.id))
    },
    destroy() {
      if (confirm('Vuoi eliminare questa vendita?')) {
        this.$inertia.delete(this.route('sales.forceDelete', this.sale.id))
      }
    },
    restore() {
      if (confirm('Vuoi ripristinare questa vendita?')) {
        this.$inertia.put(this.route('sales.restore', this.sale.id))
      }
    },
  },
}
</script>
